import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
require("highcharts/highcharts-more")(Highcharts);
require("highcharts/modules/solid-gauge")(Highcharts);

function ActivityGaugeGraph(props) {
  const graphTitle = props.title.replace(" ", "<br>");
  const color = props.color;
  const dataValue = Number(props.value) > 0 ? Number(props.value) : null;
  const Overallportfolio = {
    credits: {
      enabled: false,
    },
    chart: {
      type: "solidgauge",
      height: 130,
      width: 130,
      plotAreaWidth: 130,
      plotAreaHeight: 130,
    },

    title: {
      text: `${graphTitle}`,
      align: "center",
      verticalAlign: "middle",
      y: 20, // for title top margin
    },

    tooltip: false,
    pane: {
      startAngle: 0,
      endAngle: 360,
      background: [
        {
          // Track for Move
          outerRadius: "112%",
          innerRadius: "88%",
          backgroundColor: `rgba(${color},0.25)`,
          borderWidth: 0,
        },
      ],
    },

    yAxis: {
      min: 0,
      max: 100,
      lineWidth: 0,
      tickPositions: [],
    },

    plotOptions: {
      solidgauge: {
        dataLabels: {
          enabled: false,
        },
        linecap: "round",
        stickyTracking: false,
        rounded: true,
      },
    },

    series: [
      {
        data: [
          {
            color: `rgba(${color}, 1)`,
            radius: "112%",
            innerRadius: "88%",
            y: dataValue,
          },
        ],
      },
    ],
  };
  return (
    <>
      <HighchartsReact highcharts={Highcharts} options={Overallportfolio} />
    </>
  );
}

export default ActivityGaugeGraph;
